import { withUser } from 'components/queries/GetUserQuery';
import ProtectedRoute from './ProtectedRoute';

export default withUser(ProtectedRoute);
